import { Car, Wrench } from "lucide-react";

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="w-20 h-20 bg-[#EFDF00] flex items-center justify-center mx-auto mb-8">
          <Car className="w-10 h-10 text-black" />
        </div>
        
        {/* Title */}
        <h1 className="font-nouvel text-4xl text-white mb-4">
          Auto Thurm
        </h1>
        
        {/* Maintenance Message */}
        <div className="bg-[#EFDF00] p-6 mb-6">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Wrench className="w-6 h-6 text-black" />
            <h2 className="font-read font-bold text-xl text-black uppercase">
              Wartungsarbeiten
            </h2>
          </div>
          <p className="font-read text-black">
            Wir arbeiten gerade an unserer Website. 
            Bitte besuchen Sie uns später erneut.
          </p>
        </div>
        
        {/* Contact Info */}
        <div className="text-[#888B8D] font-read text-sm">
          <p>Bei dringenden Anfragen erreichen Sie uns unter:</p>
          <p className="text-white mt-2 font-bold">Tel: 09682 722</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
